import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=35c4f0ad&scoped=true"
import script from "./Default.vue?vue&type=script&lang=ts"
export * from "./Default.vue?vue&type=script&lang=ts"
import style0 from "./Default.vue?vue&type=style&index=0&id=35c4f0ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c4f0ad",
  null
  
)

export default component.exports